import {useContext, useEffect, useState} from "react";
import DinoHero from "../components/DinoHero";
import DinoCarousel from "../components/DinoCarousel";
import Services from "../components/Services";
import Colleagues from "../components/Colleagues";
import DinoContact from "../components/DinoContact";
import Maps from "../components/Maps";
import {getSubdomain} from "../utils/Utils";
import Base from "./Base";
import useCallDataApi from "../hooks/data";
import {useHistory} from "react-router-dom";
import Loading from "../components/Loading";
import ConfigContext from "../context/ConfigContext";

const ServiceProvider = () => {
    const {getData: fetchHomePageImages} = useCallDataApi('sp-home-screen-images')
    const {getData: fetchColleagues} = useCallDataApi('sp-colleagues')
    const {getData: fetchServices} = useCallDataApi('sp-services')
    const {getData: fetchBusinesses} = useCallDataApi('sp-businesses')

    const [businessData, setBusinessData] = useState({});
    const [homePageImages, setHomePageImages] = useState([]);
    const [colleagues, setColleagues] = useState([]);
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(false);

    const subdomain = getSubdomain()
    const history = useHistory()

    const {config} = useContext(ConfigContext)

    useEffect(() => {
        setLoading(true)
        Promise.all([
            fetchHomePageImages(`get_for_business/?business=${subdomain}`),
            fetchColleagues(`get_for_business/?business=${subdomain}`),
            fetchServices(`get_for_business/?business=${subdomain}`),
            fetchBusinesses(subdomain + '/')
        ])
            .then(([h, c, s, b]) => {
                setHomePageImages(h)
                setColleagues(c)
                setServices(s)
                setBusinessData(b)
                document.title = b.public_name

            })
            .finally(() => setLoading(false))
    }, [])


    if (config?.usage_type === 'only_booking') {
        history.push('/book')
    }

    return (
        <Base>
            <div className="inline-hero" id="home">
                <DinoHero
                    heading={businessData?.hero_heading}
                    description={businessData?.hero_text}
                    style={{width: '100%'}}
                />
                <DinoCarousel images={homePageImages}/>
            </div>
            <Services
                services={services}
                heading={businessData?.category_heading}
                text={businessData?.category_text}/>
            <Colleagues
                colleagues={colleagues}
                heading={businessData?.colleagues_heading}
                text={businessData?.colleagues_text}/>
            <div className="inline-hero" id="contact-us">
                <DinoContact
                    heading={businessData?.contact_heading}
                    description={businessData?.contact_text}
                    email={businessData?.public_email}
                    phone={businessData?.public_phone}
                    address={businessData?.public_address}
                    facebook={businessData?.facebook}
                    instagram={businessData?.instagram}
                    youtube={businessData?.youtube}
                    twitter={businessData?.twitter}
                    tiktok={businessData?.tiktok}
                    style={{width: '100%'}}
                />
                <Maps
                    embed={businessData?.maps}
                />
            </div>
            <Loading isLoading={loading}/>
        </Base>);
}

export default ServiceProvider